<template>
  <span
    class="token-badge"
    :style="{ color: badge.color, background: tint }"
  >
    {{ badge.label }}
  </span>
</template>

<script>
export default {
  name: "TokenBadge",
  props: {
    badge: {
      type: Object,
      required: true,
    },
  },
  computed: {
    tint() {
      // 14% tint of the badge colour.
      const hex = this.badge.color.replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, 0.12)`;
    },
  },
};
</script>

<style lang="scss" scoped>
.token-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 500;
  white-space: nowrap;
  line-height: 1.2;
}
</style>
